import { IProductsOffered } from "./products.interface";

export interface IShop {
  id: number;
  active: boolean;
  name: string;
  description: string;
  created_at: string;
  updated_at: string;
  products_offered?: any;
}

export interface IAdminShop {
  id: number;
  active: boolean;
  name: string;
  edit_loading: boolean;
  edit_name: string;
  edit_active: boolean;
  edit_partneris?:boolean;
  edit_description?:string;
  edit_mode: boolean; 
  created_at?: string;
  updated_at?: string;
  partneris?:boolean;
  description?: string;
}

export interface IProductShop {
  shop: {
    products_offered: IProductsOffered[];
    id: number;
    active: boolean;
    name: string;
    created_at: string;
    updated_at: string;
    description: string;
  }
}

export interface INewShop {
  name: string;
  active: boolean;
  partneris?: boolean;
  save_loading: boolean;
  description?: string;
}

export interface ChangeShopSettings {
  name: string;
  active: boolean;
  partneris?: boolean;
  description?: string;
}